import { render } from "./ListePermissionPage.vue?vue&type=template&id=426a0203&ts=true"
import script from "./ListePermissionPage.vue?vue&type=script&lang=ts"
export * from "./ListePermissionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__